var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"skeletion-breath skeletion-pagination-box"},[_c('ul',{staticClass:"d-flex f-align-center"},_vm._l(([1,2,3,4,5,6,7,8]),function(item,index){return _c('li',{key:index,staticClass:"skeletion-light pager-number",class:{ 'skeletion-dark': index === 0, 'el-icon el-icon-more': index === 6 }})}))])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-375e5124","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/skeletion/pagination.vue
// module id = null
// module chunks = 